import { DrawerContentContainer } from '../../AdminDrawer/AdminDrawer.styles';
import UserInfo from './components/UserInfo';
import ActionMenus from './components/ActionMenus';
import ActionButtons from './components/ActionButtons';
import { useSelector } from 'react-redux';
import { selectSelectedEmployee } from '../../../redux/people/peopleSlice';

const UserAccountPanel = ({ handleCloseDrawer, handleOpenDrawer }) => {
  const employee = useSelector(selectSelectedEmployee);
  return (
    <DrawerContentContainer>
      <UserInfo employee={employee} />
      <ActionMenus handleOpenDrawer={handleOpenDrawer} employee={employee} />
      <ActionButtons />
    </DrawerContentContainer>
  );
};

export default UserAccountPanel;
